const inventoryEn = {
  "nav.inventory": "Inventory",
  "nav.transfers": "Transfers",
  "nav.purchase_orders": "Purchase orders",
  "settings.locations": "Warehouses",
  "settings.locations_hint": "Warehouses, shops and pickup points",
  "settings.inventory": "Inventory",
  "settings.inventory_hint": "Reservations and low-stock alerts",
  "inv.title": "Inventory",
  "inv.all_locations": "All locations",
  "inv.search": "Search by product, SKU or barcode",
  "inv.filter.low": "Low stock",
  "inv.filter.out": "Out of stock",
  "inv.col.product": "Product",
  "inv.col.sku": "SKU",
  "inv.col.unavailable": "Unavailable",
  "inv.col.committed": "Committed",
  "inv.col.available": "Available",
  "inv.col.on_hand": "On hand",
  "inv.col.incoming": "Incoming",
  "inv.untracked": "Not tracked",
  "inv.edit_needs_location": "Choose a location to edit quantities.",
  "inv.save_changes": "Save {n} changes",
  "inv.saved": "Inventory updated",
  "inv.history": "Adjustment history",
  "inv.history_empty": "No changes yet.",
  "inv.import": "Import",
  "inv.export": "Export",
  "inv.import_title": "Import quantities",
  "inv.import_hint": "CSV with SKU (or Barcode), Location and Available columns. Export first to get a ready-made file.",
  "inv.import_set": "Replace quantities (set Available to the file's value)",
  "inv.import_adjust": "Adjust quantities (add the file's value)",
  "inv.import_done": "{updated} updated, {failed} failed",
  "inv.counts": "Stock counts",
  "inv.empty_title": "Nothing to count yet",
  "inv.empty_body": "Add products to track their stock here.",
  "inv.move": "Move units",
  "inv.qty": "Quantity",
  "inv.from": "From",
  "inv.to": "To",
  "inv.track": "Track quantity",
  "inv.threshold": "Low stock alert at",
  "inv.store_default": "Store default",
  "inv.per_location": "Quantity per location",
  "inv.total_available": "{n} available",
  "inv.breakdown": "Stock breakdown",
  "state.available": "Available",
  "state.committed": "Committed",
  "state.reserved": "Reserved",
  "state.incoming": "Incoming",
  "state.damaged": "Damaged",
  "state.safety_stock": "Safety stock",
  "state.quality_control": "Quality control",
  "reason.received": "Received",
  "reason.correction": "Correction",
  "reason.sale": "Sale",
  "reason.return_restock": "Return restocked",
  "reason.damaged": "Damaged",
  "reason.shrinkage": "Theft or loss",
  "reason.transfer_out": "Transfer out",
  "reason.transfer_in": "Transfer in",
  "reason.reservation": "Checkout hold",
  "reason.reservation_release": "Hold released",
  "reason.fulfillment": "Fulfilled",
  "reason.cycle_count": "Stock count",
  "reason.promotion": "Promotion",
  "reason.movement": "Moved between states",
  "reason.other": "Other",
  "loc.intro": "Locations are the places you stock products and fulfil orders from: a shop, a warehouse, your home.",
  "loc.empty": "No locations yet.",
  "loc.details": "Location details",
  "loc.name_hint": "Shown to customers when they pick up from here.",
  "loc.fulfillment": "Fulfillment",
  "loc.fulfils_hint": "Online orders can be fulfilled from stock at this location.",
  "loc.fulfils_short": "Fulfils online orders",
  "loc.pickup_title": "Local pickup",
  "loc.pickup_badge": "Pickup",
  "loc.pickup_hint": "Customers can choose to collect their order here at checkout.",
  "loc.pickup_instructions_hint": "Sent with the ready-for-pickup notification, e.g. parking or opening hours.",
  "loc.ready.1h": "1 hour",
  "loc.ready.2h": "2 hours",
  "loc.ready.4h": "4 hours",
  "loc.ready.24h": "24 hours",
  "loc.ready.2d": "2 days",
  "loc.ready.5d": "5 days",
  "loc.id": "Location ID",
  "loc.copy_id": "Copy location ID",
  "loc.id_hint": "Use it as location_id when you update inventory through the API.",
  "loc.inventory": "Inventory",
  "loc.stocked_items": "Variants in stock",
  "loc.stock_summary": "{items} variants · {units} units",
  "loc.view_inventory": "View inventory at this location",
  "loc.status": "Status",
  "loc.active_hint": "Active: stock here can be sold and adjusted.",
  "loc.inactive_hint": "Inactive: stock here isn't sold. Activate it to use it again.",
  "loc.deactivate_title": "Deactivate {name}?",
  "loc.deactivate_body": "Its stock stops counting toward what you can sell. You can activate it again later.",
  "loc.deactivated": "Location deactivated.",
  "loc.activated": "Location activated.",
  "loc.delete_body": "The location is removed for good. Its history stays in the inventory log.",
  "loc.delete_has_stock": "Move or remove its stock before deleting it.",
  "loc.title": "Locations",
  "loc.add": "Add location",
  "loc.name": "Location name",
  "loc.address1": "Address",
  "loc.address2": "Apartment, building, etc.",
  "loc.city": "City",
  "loc.region": "Region",
  "loc.postal": "Postal code",
  "loc.country": "Country code",
  "loc.phone": "Phone",
  "loc.fulfils": "Fulfil online orders from this location",
  "loc.pickup": "Offer local pickup here",
  "loc.pickup_instructions": "Pickup instructions",
  "loc.pickup_ready": "Usually ready in",
  "loc.inactive": "Inactive",
  "loc.deactivate": "Deactivate",
  "loc.activate": "Activate",
  "loc.delete_confirm": "Delete {name}?",
  "invset.reserve_at": "Hold stock for customers",
  "invset.reserve_checkout": "When they reach the payment step (recommended)",
  "invset.reserve_order": "Only when the order is placed",
  "invset.reservation_minutes": "Hold for (minutes)",
  "invset.threshold": "Low stock threshold (default)",
  "invset.digest": "Email me a daily low-stock summary",
  "tr.title": "Transfers",
  "tr.add": "Create transfer",
  "tr.origin": "Origin",
  "tr.destination": "Destination",
  "tr.expected": "Expected arrival",
  "tr.reference": "Tracking / reference",
  "tr.notes": "Notes",
  "tr.items": "Items",
  "tr.add_items": "Add items",
  "tr.status.draft": "Draft",
  "tr.status.in_transit": "In transit",
  "tr.status.partially_received": "Partially received",
  "tr.status.received": "Received",
  "tr.status.cancelled": "Cancelled",
  "tr.ship": "Mark as in transit",
  "tr.receive": "Receive items",
  "tr.accept": "Accept",
  "tr.reject": "Reject",
  "tr.remaining": "Remaining",
  "tr.cancel": "Cancel transfer",
  "tr.cancel_confirm": "Cancel this transfer? Units not received go back to the origin.",
  "tr.empty": "Move stock between your locations with transfers.",
  "tr.received_of": "{received} of {total} received",
  "po.title": "Purchase orders",
  "po.add": "Create purchase order",
  "po.supplier": "Supplier",
  "po.no_supplier": "No supplier",
  "po.new_supplier": "New supplier",
  "po.destination": "Destination",
  "po.currency": "Currency",
  "po.terms": "Payment terms",
  "po.expected": "Estimated arrival",
  "po.shipping": "Shipping",
  "po.reference": "Reference number",
  "po.notes": "Notes to supplier",
  "po.cost": "Cost",
  "po.subtotal": "Subtotal",
  "po.total": "Total",
  "po.status.draft": "Draft",
  "po.status.ordered": "Ordered",
  "po.status.partially_received": "Partially received",
  "po.status.received": "Received",
  "po.status.closed": "Closed",
  "po.status.cancelled": "Cancelled",
  "po.mark_ordered": "Mark as ordered",
  "po.receive": "Receive inventory",
  "po.update_cost": "Update product cost (weighted average)",
  "po.close": "Close purchase order",
  "po.close_confirm": "Close this purchase order? Items not received are no longer expected.",
  "po.pdf": "Download PDF",
  "po.empty": "Order stock from suppliers and receive it into a location.",
  "po.supplier_name": "Supplier name",
  "po.contact_name": "Contact name",
  "po.email": "Email",
  "po.phone": "Phone",
  "count.title": "Stock counts",
  "count.add": "Start a count",
  "count.name": "Name",
  "count.location": "Location",
  "count.scan": "Scan or enter a barcode / SKU",
  "count.scan_hint": "A barcode scanner types into this box. Each scan adds one.",
  "count.camera": "Scan with camera",
  "count.camera_stop": "Stop camera",
  "count.camera_unsupported": "This browser can't scan barcodes with the camera. Use a scanner or type the code.",
  "count.expected": "Expected",
  "count.counted": "Counted",
  "count.variance": "Variance",
  "count.apply": "Apply count",
  "count.apply_confirm": "Apply the counted variances to inventory?",
  "count.cancel": "Cancel count",
  "count.status.open": "Open",
  "count.status.applied": "Applied",
  "count.status.cancelled": "Cancelled",
  "count.progress": "{counted} of {total} counted",
  "count.empty": "Count your stock to fix differences between the system and the shelf.",
  "count.scanned": "{title}: {counted}",
  "picker.title": "Add items",
  "picker.add": "Add {n}",
} as const;

export default inventoryEn;
